// ******************************************************
// ******************************************************
// ******************************************************
// *****    Definition of the Textures.
// *****    This code is generated. Do not edit manaully.
// ******************************************************
// ******************************************************
// ******************************************************
import { tbTexture } from "../../engine/tbTexture";
export var texture;
export var characterAnimations;
export var endScreens;
export var extraAnimations;
export var placeHolder;
export var tntExplosion;
export var CustomUpdates_blue_2;
export var CustomUpdates_green_2;
export var CustomUpdates_red_2;
export var scene_blue_2;
export var StaticTexture;
export var StaticTexture_red_1;
export var textureUI_blue_2;
export var textureUI_green_1;
export var textureUI_green_2;
export var textureUI_red_1;
export var textureUI_red_2;
export var texture_blue_1;
export var texture_blue_2;
export var texture_fake_players;
export var texture_green_1;
export var texture_green_2;
export var texture_red_1;
export var texture_red_2;
export var blocks;
export var CustomUpdates;
export var textureUI;
export var FrameworkTexture_blue_1;
export var FrameworkTexture_blue_2;
export var FrameworkTexture_green_2;
export var FrameworkTexture_red_1;
export var FrameworkTexture_red_2;
export var FrameworkTexture;
export var textureSplash_blue_2;
export var textureSplash_red_2;
export var textureSplash;
export var initializeTextures = function () {
    texture = new tbTexture("texture", 1, "images");
    texture.addBitmap(0, "media/texture.json");
    characterAnimations = new tbTexture("characterAnimations", 1, "images");
    characterAnimations.addBitmap(0, "media/characterAnimations.json");
    endScreens = new tbTexture("endScreens", 2, "images");
    endScreens.addBitmap(0, "media/endScreens-0.json");
    endScreens.addBitmap(1, "media/endScreens-1.json");
    CustomUpdates_blue_2 = new tbTexture("CustomUpdates_blue_2", 1, "images");
    CustomUpdates_blue_2.addBitmap(0, "media/CustomUpdates_blue_2.json");
    CustomUpdates_red_2 = new tbTexture("CustomUpdates_red_2", 1, "images");
    CustomUpdates_red_2.addBitmap(0, "media/CustomUpdates_red_2.json");
    StaticTexture_red_1 = new tbTexture("StaticTexture_red_1", 1, "images");
    StaticTexture_red_1.addBitmap(0, "media/StaticTexture_red_1.json");
    textureUI_blue_2 = new tbTexture("textureUI_blue_2", 1, "images");
    textureUI_blue_2.addBitmap(0, "media/textureUI_blue_2.json");
    textureUI_green_1 = new tbTexture("textureUI_green_1", 1, "images");
    textureUI_green_1.addBitmap(0, "media/textureUI_green_1.json");
    textureUI_green_2 = new tbTexture("textureUI_green_2", 1, "images");
    textureUI_green_2.addBitmap(0, "media/textureUI_green_2.json");
    textureUI_red_1 = new tbTexture("textureUI_red_1", 1, "images");
    textureUI_red_1.addBitmap(0, "media/textureUI_red_1.json");
    textureUI_red_2 = new tbTexture("textureUI_red_2", 1, "images");
    textureUI_red_2.addBitmap(0, "media/textureUI_red_2.json");
    texture_blue_1 = new tbTexture("texture_blue_1", 1, "images");
    texture_blue_1.addBitmap(0, "media/texture_blue_1.json");
    texture_blue_2 = new tbTexture("texture_blue_2", 1, "images");
    texture_blue_2.addBitmap(0, "media/texture_blue_2.json");
    texture_fake_players = new tbTexture("texture_fake_players", 1, "images");
    texture_fake_players.addBitmap(0, "media/texture_fake_players.json");
    texture_green_1 = new tbTexture("texture_green_1", 1, "images");
    texture_green_1.addBitmap(0, "media/texture_green_1.json");
    texture_green_2 = new tbTexture("texture_green_2", 1, "images");
    texture_green_2.addBitmap(0, "media/texture_green_2.json");
    texture_red_1 = new tbTexture("texture_red_1", 1, "images");
    texture_red_1.addBitmap(0, "media/texture_red_1.json");
    texture_red_2 = new tbTexture("texture_red_2", 1, "images");
    texture_red_2.addBitmap(0, "media/texture_red_2.json");
    blocks = new tbTexture("blocks", 1, "images");
    blocks.addBitmap(0, "media/blocks.json");
    textureUI = new tbTexture("textureUI", 1, "images");
    textureUI.addBitmap(0, "media/textureUI.json");
    FrameworkTexture_blue_1 = new tbTexture("FrameworkTexture_blue_1", 1, "frameworkImages");
    FrameworkTexture_blue_1.addBitmap(0, "media/FrameworkTexture_blue_1.json");
    FrameworkTexture_blue_2 = new tbTexture("FrameworkTexture_blue_2", 1, "frameworkImages");
    FrameworkTexture_blue_2.addBitmap(0, "media/FrameworkTexture_blue_2.json");
    FrameworkTexture_green_2 = new tbTexture("FrameworkTexture_green_2", 1, "frameworkImages");
    FrameworkTexture_green_2.addBitmap(0, "media/FrameworkTexture_green_2.json");
    FrameworkTexture_red_1 = new tbTexture("FrameworkTexture_red_1", 1, "frameworkImages");
    FrameworkTexture_red_1.addBitmap(0, "media/FrameworkTexture_red_1.json");
    FrameworkTexture_red_2 = new tbTexture("FrameworkTexture_red_2", 1, "frameworkImages");
    FrameworkTexture_red_2.addBitmap(0, "media/FrameworkTexture_red_2.json");
    textureSplash_blue_2 = new tbTexture("textureSplash_blue_2", 1, "splashImages");
    textureSplash_blue_2.addBitmap(0, "media/textureSplash_blue_2.json");
    textureSplash_red_2 = new tbTexture("textureSplash_red_2", 1, "splashImages");
    textureSplash_red_2.addBitmap(0, "media/textureSplash_red_2.json");
};
